import { Injectable } from '@angular/core';
import { AuthHttp } from './auth.http';
import { ConfigStore } from '../stores/config.store';

@Injectable()
export class ImagesService {

    constructor(private http: AuthHttp, private config: ConfigStore) { }

    public images(id: string) {

        let baseUrl: string = this.config.getValue('webServiceURL');
        let url: string = baseUrl + '/api/immagini/' + id;

        return this.http.get(
            url
        ).map(response => {

            let json = response.json();

            // console.log('[ImagesService] images | json:');
            // console.log(json);

            return json;
        }).share();
    }    
}


// WEBPACK FOOTER //
// ./src/services/images.service.ts